import { PAGE_BUILDER_SOURCES } from "../constants/SalesPages.constants";

export const checkPgBuilderSourceIsGJS = (pgBuilderSource) =>
  pgBuilderSource === PAGE_BUILDER_SOURCES.grapes_js;
